// import SiteService from '@/services/requests/siteService'
import Store from '@/store/computed/storeHelpers'
import Api from '@/services/api'

export default {
  methods: {
    getSites() {
      this.loadingSites = true
      var urlString = 'sites'
      if (!!this.includeInactive) urlString += '/includeInactive'
      return Api.get(urlString)
        .then(result => {
          this.loadingSites = false
          this.sites = result.data.result
          return result.data.result
        })
        .catch(err => {
          console.log(err)
          this.loadingSites = false
          this.snackError()
        })
    }
  },
  computed: {
    loadingSites: Store.getSet({ store: 'sites', prop: 'loadingSites' }),
    sites: Store.getSet({ store: 'sites', prop: 'sites' })
  },
  mounted() {
    if (!this.sites.length && this.$route.name !== 'audit') {
      this.getSites()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.sites = []
  }
}
